import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/app/ui/assets/svg/calendar.svg'
import _imports_1 from '@/app/ui/assets/svg/ics_o_chevron_left.svg'


const _hoisted_1 = /*#__PURE__*/_createVNode("div", {
  class: "flex flex-row align-middle items-center bg-gray-lp-700 rounded-l-md text-black-lp-300 text-center border-r-0 border-gray-lp-400 border outline-none focus:shadow px-2.5",
  style: {"height":"39px"}
}, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: "calendar"
  })
], -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  class: "ml-3",
  style: {"transform":"rotate(270deg)"},
  src: _imports_1,
  alt: "next",
  width: "16",
  height: "16"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_BottomSheet = _resolveComponent("BottomSheet")!

  return (_openBlock(), _createBlock("section", {
    class: ["w-full", _ctx.customClass]
  }, [
    _createVNode("button", {
      class: 
        `flex flex-row items-center relative w-full ${
          _ctx.disabled ? 'cursor-not-allowed' : 'cursor-pointer'
        }`
      ,
      style: {"height":"100%"},
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openSheet && _ctx.openSheet(...args)))
    }, [
      _hoisted_1,
      _createVNode("div", {
        class: ["\n          flex flex-row align-middle justify-between items-center rounded-r-md px-2 text-sm font-light text-center w-full border-gray-lp-400 border\n        ", `${_ctx.disabled ? 'text-gray-lp-600' : 'text-black-lp-300'}`],
        style: {"height":"39px"}
      }, [
        _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
        _hoisted_2
      ], 2),
      _hoisted_3
    ], 2),
    _createVNode(_component_BottomSheet, {
      modelValue: _ctx.isSheetOpen,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.isSheetOpen = $event)),
      title: "Pilih Rentang Waktu"
    }, {
      default: _withCtx(() => [
        _createVNode("div", null, [
          (_ctx.isSheetOpen)
            ? (_openBlock(), _createBlock(_component_DatePicker, {
                key: 0,
                type: _ctx.type,
                modelValue: _ctx.modelValue,
                maxDate: _ctx.maxDate,
                minDate: _ctx.minDate,
                "onUpdate:modelValue": _ctx.onChange
              }, null, 8, ["type", "modelValue", "maxDate", "minDate", "onUpdate:modelValue"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 2))
}